// Simple profanity filter for usernames
const profanityList = [
  // Common profanity - keeping it minimal but effective
  'fuck', 'shit', 'damn', 'bitch', 'ass', 'crap', 'piss', 'bastard',
  'hell', 'cock', 'dick', 'pussy', 'whore', 'slut', 'fag', 'nigger',
  'nazi', 'hitler', 'kill', 'die', 'hate', 'rape', 'murder',
  // Variations and common substitutions
  'f*ck', 'f**k', 'sh*t', 'sh**', 'b*tch', 'a**', 'h*ll',
  'f@ck', 'sh!t', 'b!tch', 'a$$', 'h3ll', 'd@mn',
  // L33t speak variations
  'fuk', 'shyt', 'b1tch', 'h3ll', 'k1ll', 'd13'
]

// Additional pattern-based checks
const suspiciousPatterns = [
  /(.)\1{4,}/, // Repeated characters (aaaaa)
  /^[^\w\s]*$/, // Only special characters
  /^\d+$/, // Only numbers
  /^.{1,2}$/, // Too short (1-2 characters)
  /^.{25,}$/, // Too long (25+ characters)
]

export const isProfane = (text) => {
  if (!text || typeof text !== 'string') return true
  
  const cleaned = text.toLowerCase().trim()
  
  // Check against profanity list
  for (const word of profanityList) {
    if (cleaned.includes(word)) {
      return true
    }
  }
  
  // Check against suspicious patterns
  for (const pattern of suspiciousPatterns) {
    if (pattern.test(cleaned)) {
      return true
    }
  }
  
  return false
}

export const sanitizeUsername = (username) => {
  if (!username || typeof username !== 'string') return ''
  
  // Remove extra whitespace and limit length
  return username.trim().slice(0, 24)
}

export const validateUsername = (username) => {
  const sanitized = sanitizeUsername(username)
  
  if (!sanitized) {
    return { valid: false, error: 'Username cannot be empty' }
  }
  
  if (sanitized.length < 2) {
    return { valid: false, error: 'Username must be at least 2 characters' }
  }
  
  if (isProfane(sanitized)) {
    return { valid: false, error: 'Please choose a different username' }
  }
  
  return { valid: true, username: sanitized }
}